import { TableContentLoader } from '@common/TableContentLoader';
import { useAppConfigs } from '@config/config.hooks';
import { useIsLoggedIn } from '@gcl/react-core';
import { useGetProjectByProjectNoAsync } from '@project/project.queries';
import { useNavigate } from '@routes/routes.hooks';
import { routes } from '@routes/routes.models';
import { useQueryClient } from '@tanstack/react-query';
import { Navigate } from 'react-router-dom';

export const ProjectHome = () => {
  const queryClient = useQueryClient();
  const isLoggedIn = useIsLoggedIn();
  const appConfigs = useAppConfigs();
  const { navigate, generateRoutePath, projectNoFromUrl } = useNavigate();
  const { data: project, isLoading } = useGetProjectByProjectNoAsync(projectNoFromUrl);

  if (isLoading || projectNoFromUrl !== project?.item?.projectNo) {
    return (
      <div className="gcl-px-md gcl-mx-xl gcl-my-md">
        <TableContentLoader />
      </div>
    );
  }

  if ((isLoggedIn && !project?.item) || !project?.item?.id) {
    navigate(routes.common.pageNotFound.path);
    return <></>;
  }

  if (project?.item?.id) {
    queryClient.invalidateQueries([project?.item?.id]);
    if (appConfigs.updateConfigs && typeof appConfigs.updateConfigs === 'function') {
      appConfigs.updateConfigs((configs) => {
        configs.project = project?.item;
        return configs;
      });
    }
  }

  return <Navigate to={generateRoutePath(routes.t1.path, { projectNo: project?.item?.projectNo }, false)} />;
};
